






































import { Component, Prop, Vue } from 'vue-property-decorator';
import { Button, Option, Select } from 'element-ui';
import { SelectOption } from '@/types/types';

type CallbackFunction = (value: string, onSuccessCallback: Function, onFailCallback: Function) => void;

@Component({
  components: {
    'el-button': Button,
    'el-option': Option,
    'el-select': Select
  }
})
export default class CreateSelect extends Vue {
  @Prop({ default: null, type: String }) value!: string | null; // id or value
  @Prop({ required: true, type: Function }) create: CallbackFunction;
  @Prop({ required: true, type: Array }) data: SelectOption<any>[];
  @Prop({ default: false, type: Boolean }) disabled!: boolean;
  @Prop({ default: false, type: Boolean }) freeInput!: boolean; // determines if user can use a value without creating it
  @Prop({ default: false, type: Boolean }) useValue: boolean; // determines if model needs an ID or Value

  private options = [];
  private loading = false;
  private querying = false;
  private currentQuery = null;

  public $refs!: {
    select: HTMLElement;
  };

  get showAddButton() {
    return ((this.options.length === 0) && !this.loading);
  }

  get content(): string {
    const value = this.useValue ? this.value : this.findValueByID(this.value);
    if (value) {
      this.remoteMethod(value);
    } else {
      this.remoteMethod('');
    }
    return value;
  }

  set content(value: string) {
    const emitValue = this.useValue ? value : this.findIdByValue(value);
    this.$emit('input', emitValue);
    this.$emit('change', emitValue);
  }

  // Basic filtering on label OR value
  private remoteMethod(query) {
    if (query !== '') {
      this.currentQuery = query;
      this.options = this.data.filter(item => {
        return (item.label?.toLowerCase()
          .indexOf(query.toLowerCase()) > -1) ||
          (item.value?.toString().toLowerCase()
            .indexOf(query.toLowerCase()) > -1);
      });
    } else {
      this.options = [];
    }
  }

  private findValueByID(id) {
    return this.data.find(option => option.id === id)?.value;
  }

  private findIdByValue(value) {
    return this.data.find(option => option.value === value)?.id;
  }

  // Calls the create prop with the current query, then closes the select
  private createFunc() {
    this.querying = true;
    this.create(this.currentQuery, this.createSucess, this.createFail);
  }

  /**
   * Create Success & Create Fail:
   *    Provide parent component with success / fail condition alerts in createFunc
   */
  private createSucess() {
    this.$store.dispatch('Alert/addAlert', {
      type: 'success',
      message: this.$t('success.created'),
      time: 2000
    });
    this.$refs.select.blur();
    this.querying = false;
  }

  private createFail() {
    this.querying = false;
    this.$store.dispatch('Alert/addAlert', {
      type: 'error',
      message: this.$t('error.push'),
      time: 2000
    });
  }
}
